<template>
    <div>
      <b-card sub-title="Visitors Details (Name, Phone)">
        <div v-for="(v, index) in $v.members.$each.$iter" :key="index">
          <hr v-if="index > 0" class="members-row"/>
          <b-row >
            <b-col lg="3"><b-form-input type="text" class="form-control" v-model="v.name.$model" :state="chkState('name', index)" placeholder="Name"></b-form-input></b-col>
            <b-col lg="3"><b-form-input type="number" class="form-control" v-model="v.phone.$model" :state="chkState('phone', index)" placeholder="Phone"></b-form-input></b-col>
          </b-row>
        </div>
      </b-card>
  
      <div class="alert alert-danger" v-if="!$v.members.required && $v.members.$dirty">Please provide at least one member</div>
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  
  import {
    required
  } from "vuelidate/lib/validators"
  
  export default {
    name: 'GateMemberList',
    computed: {
      isValid() {
        return !this.$v.members.$anyError
      },
      isDirty() {
        return this.$v.members.$anyDirty
      }
    },
    data: function () {
      return {
        total: 0,
        members: []
      };
    },
    validations: {
      members: {
        required,
        $each: {
          name: {
            required,
          },
          phone: {  
            required          
          }
        }
      }
    },
    methods: {   
      addMember() {
        this.members.push({name: "",  phone: ""})
      },
      removeMember() {
        this.members.pop()
      },
      getMembers() {
        return this.members
      },
      getMembersCount(){
        return this.members.length
      },
      setMember(member){
      
        this.members.push({name: member.name, phone: member.phone})

      },
     
      onReset() {
        this.members = []
        this.$nextTick(() => {
          this.$v.$reset()
        })
      },
      chkState(val, index) {
        const field = this.$v.members.$each[index][val]
        return field.$dirty ? !field.$invalid : null
      },
      findFirstError(component = this) {
        if (component.state === false) {
          if (component.$refs.input) {
            component.$refs.input.focus()
            return true
          }
          if (component.$refs.check) {
            component.$refs.check.focus()
            return true
          }
        }
        let focused = false
        component.$children.some((child) => {
          focused = this.findFirstError(child)
          return focused
        })
  
        return focused
      },
      validate() {
        this.$v.$touch()
        this.$nextTick(() => this.findFirstError())
        return this.isValid
      }
    },
    created() {
  
    },
  }
  </script>
  
  <style>
  .members-row {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  </style>
  